import React from 'react';
import { NotebookPen } from 'lucide-react';

export default function SelectedCarrierWithoutStates() {
  return (
    <div className='show-scrollbar flex min-h-0 w-full flex-1 flex-col gap-4 rounded-xl bg-white'>
      <div className='pd-tp-1/2 flex w-full flex-row items-start gap-3 rounded-lg border border-secondary-darkest bg-secondary-light px-3 py-2.5 text-left text-sm font-medium text-gray-900 transition-colors duration-200 ease-in-out sm:items-center sm:gap-4'>
        <div className='bg-white/80 border-2 border-secondary-darkest rounded-full p-4 flex items-center justify-center'>
          <NotebookPen className='size-12 stroke-[1.5] text-secondary-darkest' />
        </div>
        <div className='flex min-w-0 flex-1 flex-col gap-1'>
          <h4 className='m-0 text-lg'>Simplified Appointment Process</h4>
          <span className='font-normal'>
            No state-specific appointment is required for this carrier.
          </span>
        </div>
      </div>
    </div>
  );
}
